<template>
  <div class="layout">
    <TildaPage
      v-if="landing?.rawData.tilda_page_data"
      :data="landing?.rawData.tilda_page_data"
    />

    <div v-else class="layout__content">
      <div class="layout__breadcrumbs ui-container">
        <UiBackButton
          v-if="isMobile"
          :link="`${config.public.frontUrl}/catalog/`"
          class="layout__back-button"
        >
          <span class="f f--2 f--m">
            {{ breadcrumbs[0]?.title }}
          </span>
        </UiBackButton>

        <UiBreadcrumbs
          v-else
          :breadcrumbs="breadcrumbs"
          class="layout__breadcrumbs-list"
        />
      </div>

      <main class="course-page">
        <div class="course-page__content">
          <div class="course-page__content-wrapper">
            <CourseCard
              v-if="isDesktop && landing?.courseCardBlock"
              v-element-visibility="(isVisibility) => isVisibility && sendLandingShowCourseCard(sendLandingAnalyticsContent)"
              :card="landing.courseCardBlock.card"
              :access-type="landing.commonData.accessType"
              :duration="landing.commonData?.duration"
              :promo="isPromo"
              :is-subscription-available="Boolean(isSubscriptionAvailable && landing.commonData?.is_subscribe_available)"
              :is-user-subscription-active="isUserSubscriptionActive"
              class="course-page__course-card"
              @click:pay="handleClickPay"
              @click="sendLandingClickCourseCard(sendLandingAnalyticsContent)"
            />

            <div class="course-page__blocks-wrapper">
              <StartScreen
                v-if="landing?.startScreenBlock && landing.courseCardBlock"
                ref="startScreen"
                v-element-visibility="(isVisibility) => isVisibility && sendLandingShowStartScreen(sendLandingAnalyticsContent)"
                :images="landing.startScreenBlock.images"
                :provider="landing.startScreenBlock.provider"
                :rating="landing.startScreenBlock.rating"
                :title="landing.startScreenBlock.title"
                :description="landing.startScreenBlock.description"
                :card="landing.courseCardBlock.card"
                :access-type="landing.commonData.accessType"
                :company-slug="landing.commonData.company.slug"
                :is-subscription-available="Boolean(isSubscriptionAvailable && landing.commonData?.is_subscribe_available)"
                class="course-page__block course-page__block--start-screen"
                @click:pay="handleClickPay"
                @click="sendLandingClickStartScreen(sendLandingAnalyticsContent)"
              />

              <WillLearn
                v-if="landing?.willLearnBlock"
                v-element-visibility="(isVisibility) => isVisibility && sendLandingShowBlockWillLearn(sendLandingAnalyticsContent)"
                :title="landing.willLearnBlock.title"
                :data="landing.willLearnBlock.data"
                class="course-page__block course-page__block--grey"
                @click="sendLandingClickBlockWillLearn(sendLandingAnalyticsContent)"
              />

              <TrailerBlock
                v-if="landing?.trailerBlock"
                :title="landing.trailerBlock.title"
                :video-src="landing.trailerBlock.videoSrc"
                class="course-page__block"
              />

              <ProgramsBlock
                v-if="landing?.programsBlock"
                :title="landing.programsBlock.title"
                :description="landing.programsBlock.description"
                :cards="landing.programsBlock.cards"
                class="course-page__block"
              />

              <CourseContent
                v-if="landing?.courseContentBlock"
                id="program"
                v-element-visibility="(isVisibility) => isVisibility && sendLandingShowBlockContent(sendLandingAnalyticsContent)"
                :title="landing.courseContentBlock.title"
                :description="landing.courseContentBlock.description"
                :info="landing.courseContentBlock.info"
                :data="landing.courseContentBlock.data"
                class="course-page__block"
                @click="sendLandingClickBlockContent(sendLandingAnalyticsContent)"
              />

              <AuthorsBlock
                v-if="landing?.authorsBlock"
                v-element-visibility="(isVisibility) => isVisibility && sendLandingShowBlockAuthors(sendLandingAnalyticsContent)"
                :title="landing.authorsBlock.title"
                :authors="landing.authorsBlock.authors"
                class="course-page__block course-page__block--grey"
                @click="sendLandingClickBlockAuthors(sendLandingAnalyticsContent)"
              />

              <RatingBlock
                v-if="reviews?.length"
                :cards="reviews"
                :rating="{ value: rating?.rating || 0 }"
                class="course-page__block"
              />

              <CertificateBlock
                v-if="landing?.certificateBlock"
                v-element-visibility="(isVisibility) => isVisibility && sendLandingShowBlockCertificate(sendLandingAnalyticsContent)"
                :data="landing.certificateBlock.data"
                class="course-page__block"
                @click="sendLandingClickBlockCertificate(sendLandingAnalyticsContent)"
                @click:button="sendLandingClickBlockCertificateButton(sendLandingAnalyticsContent)"
              />

              <FAQ
                v-if="landing?.faqBlock"
                :title="landing.faqBlock.title"
                :data="landing.faqBlock.data"
                class="course-page__block"
              />

              <AchievementBlock
                v-if="landing?.achievementBlock"
                :title="landing.achievementBlock.title"
                :cards="landing.achievementBlock.cards"
                class="course-page__block"
              />
            </div>
          </div>

          <OtherCourses
            v-if="courses && courses.length"
            :title="landing?.commonData.company.abbreviation || ''"
            :cards="courses"
            :button-link="otherCoursesLink ?? undefined"
            button-text="Смотреть все курсы"
            class="course-page__block "
            @visible:card="(event: any) => sendLandingShowCard({
              card_number: event.cardNumber,
              nomenclature_id: event.nomenclatureId,
              nomenclature_type: event.nomenclatureType,
              user_id: Number(user?.id),
            })"
            @click:card="(event: any) => sendLandingClickCard({
              card_number: event.cardNumber,
              nomenclature_id: event.nomenclatureId,
              nomenclature_type: event.nomenclatureType,
              user_id: Number(user?.id),
            })"
          />

          <PaymentModalSmart />
        </div>
      </main>
    </div>

    <client-only>
      <MobilePrice
        v-if="isMobile && landing?.courseCardBlock"
        :price="landing.courseCardBlock.card.price"
        :program="landing.courseCardBlock.card.program"
        :access-type="landing.commonData.accessType"
        :promo="isPromo"
        :is-subscription-available="Boolean(isSubscriptionAvailable && landing.commonData.is_subscribe_available)"
        class="course-page__mobile-price"
        :class="{'course-page__mobile-price--visible': isVisiblePriceBar}"
        @click:pay="handleClickPay"
      />
    </client-only>
  </div>
</template>

<script setup lang="ts">
  import type { VNodeRef } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useStorage } from '@vueuse/core'
  import { vElementVisibility } from '@vueuse/components'

  import UiBreadcrumbs from '@academica-box/components/Blocks/UiBreadcrumbs/UiBreadcrumbs.vue'
  import UiBackButton from '@academica-box/components/Buttons/UiBackButton/UiBackButton.vue'

  import { useUserStore } from '@academica-box/composables/store/user'
  import { useSubscribesStore } from '@academica-box/composables/store/subscribes'
  import { usePromoStore } from '@academica-box/composables/store/promo'
  import { sclClickPixelFn } from '@academica-box/helpers/scaleo'
  import MobilePrice from '@/components/Price/MobilePrice/MobilePrice.vue'
  import CourseCard from '@/components/Cards/CourseCard/CourseCard.vue'
  import AchievementBlock from '@/components/AchievementBlock/AchievementBlock.vue'
  import TildaPage from '@/components/TildaPage.vue'

  import PaymentModalSmart from '@/components/Modals/PaymentModal.smart/PaymentModal.smart.vue'

  import { breadcrumbs } from '@/pages/mocks'
  import { useLandingStore } from '@/store/landing'
  import { AccessTypeEnum } from '@/helpers/mappingCourseData'
  import { SmartComponents, useSmartComponentsStore } from '@/store/smartComponents'
  import {
    sendLandingShowCourseCard,
    sendLandingClickCourseCard,
    sendLandingShowStartScreen,
    sendLandingClickStartScreen,
    sendLandingShowBlockWillLearn,
    sendLandingClickBlockWillLearn,
    sendLandingShowBlockContent,
    sendLandingClickBlockContent,
    sendLandingClickBlockAuthors,
    sendLandingShowBlockAuthors,
    sendLandingShowBlockCertificate,
    sendLandingClickBlockCertificate,
    sendLandingClickBlockCertificateButton,
    sendLandingShowCard,
    sendLandingClickCard,
    sendLandingClickButton,
  } from '@/analytics/events'

  const route = useRoute()
  const config = useRuntimeConfig()
  const viewport = useViewport()
  const isMobile = computed(() => viewport.isLessThan('lg'))
  const isDesktop = computed(() => viewport.isGreaterThan('md'))
  const isSubscribeOpenModal = useStorage('is_subscribe_open_modal', false)

  const landingStore = useLandingStore()
  const { landing, courses, reviews, rating } = storeToRefs(landingStore)
  const userStore = useUserStore()
  const { user } = storeToRefs(userStore)
  const promoStore = usePromoStore()
  const { promo } = storeToRefs(promoStore)
  const smartComponentsStore = useSmartComponentsStore()
  const subscribesStore = useSubscribesStore()
  const { activeSubscription, isUserSubscriptionActive, isSubscriptionAvailable } = storeToRefs(subscribesStore)

  const sendLandingAnalyticsContent = computed(() => {
    return {
      nomenclature_id: landing?.value?.commonData.nomenclature_id,
      nomenclature_type: landing?.value?.commonData.accessType,
      user_id: Number(user?.value?.id),
    }
  })

  const computedOfferCategory = computed(() => {
    if (isSubscriptionAvailable.value && landing?.value?.commonData.is_subscribe_available) {
      return 'Subscription'
    }

    if (landing?.value?.commonData.is_auto_opening) {
      return 'Free'
    }

    return 'Paid'
  })

  const levelsMap: {
    [key: string]: string;
  } = {
    'for-novichkov': 'Beginner',
    for_specialists: 'Advanced',
  }

  const handleClickPay = (accessType: AccessTypeEnum) => {
    sendLandingClickButton({
      nomenclature_id: landing?.value?.commonData.nomenclature_id,
      nomenclature_type: accessType,
      user_id: Number(user?.value?.id),
    })

    smartComponentsStore.set(SmartComponents.PaymentModal, {
      accessType,
      isShow: true,
      isSubcribeProgress: false,
    })
  }

  const seoTitle = computed(() => {
    return `Курс «${landing?.value?.startScreenBlock?.title}» от ${landing?.value?.commonData.company.abbreviation} | Академика`
  })

  const seoDescription = computed(() => {
    if (landing?.value?.commonData.is_auto_opening) {
      return `Начать учиться бесплатно на онлайн-курсе «${landing?.value?.startScreenBlock?.title}» (${landing?.value?.commonData.company.name}) на платформе Академика.`
    }

    return `Получить доступ к онлайн-курсу «${landing?.value?.startScreenBlock?.title}» (${landing?.value?.commonData.company.name}) на платформе Академика. Сертификат об окончании курса.`
  })

  const setSeoTags = () => {
    useSeoMeta({
      title: seoTitle.value,
      description: seoDescription.value,
      // OpenGraph
      ogUrl: `https://academika.ru/course/${landing?.value?.rawData.url}`,
      ogType: 'website',
      ogTitle: seoTitle.value,
      ogDescription: seoDescription.value,
      ogImage: landing?.value?.startScreenBlock?.images.sm?.img?.['1x'],
      // Twitter OpenGraph
      twitterCard: 'summary_large_image',
      twitterTitle: seoTitle.value,
      twitterDescription: seoDescription.value,
      twitterImage: landing?.value?.startScreenBlock?.images.sm?.img?.['1x'],
    })
  }

  await useAsyncData(
    'getReviews',
    () => landingStore.getReviews(landing?.value?.commonData.nomenclature_id)
  )

  await useAsyncData(
    'getRating',
    () => landingStore.getRating(landing?.value?.commonData.nomenclature_id)
  )

  useSchemaOrg([
    defineBreadcrumb({
      itemListElement: breadcrumbs.map((breadcrumb) => {
        return {
          name: breadcrumb.title,
          item: breadcrumb.link
        }
      }),
    }),
    defineCourse({
      name: landing?.value?.startScreenBlock?.title || '',
      description: landing?.value?.startScreenBlock?.description || '',
      provider: {
        name: landing?.value?.commonData.company.name,
        url: `https://academika.ru/vendor/${landing?.value?.commonData.company.slug}`
      },
      offers: [{
        category: computedOfferCategory.value,
        priceCurrency: 'RUB',
        price: landing?.value?.courseCardBlock?.card.price.current
      }],
      hasCourseInstance: [{
        courseMode: 'Online',
        courseWorkload: landing?.value?.courseContentBlock?.info?.hours ? `PT${parseInt(landing?.value?.courseContentBlock?.info?.hours)}H` : null,
      }],
      syllabusSections: landing?.value?.commonData.course_type === 'vendor_pack'
        ? [
          landing?.value?.courseContentBlock?.data.map((item) => {
            return {
              name: item.title
            }
          })
        ]
        : null,
      aggregateRating: landing?.value?.startScreenBlock?.rating.value,
      educationalCredentialAwarded: landing?.value?.certificateBlock
        ? [
          {
            type: 'EducationalOccupationalCredential',
            credentialCategory: 'Certificate'
          }
        ]
        : null,
      educationalLevel: landing?.value?.commonData.level?.slug ? levelsMap[landing?.value?.commonData.level?.slug] : null,
      inLanguage: 'ru',
    })
  ])

  setSeoTags()

  const isVisiblePriceBar = ref(false)
  const observer = ref<IntersectionObserver | null>(null)
  const startScreen = ref<VNodeRef | null>(null)

  const changeVisiblePriceBar = ([entry]: IntersectionObserverEntry[]) => {
    isVisiblePriceBar.value = !entry?.isIntersecting
  }

  const otherCoursesLink = computed(() => {
    return `${config.public.frontUrl}/catalog/?companies=${landing?.value?.commonData.company.slug}`
  })

  const isPromo = computed(() => {
    return landing?.value?.rawData.is_promo ? promo.value : null
  })

  onMounted(() => {
    // Вызов функции для scaleo
    sclClickPixelFn()

    observer.value = new IntersectionObserver(changeVisiblePriceBar, { rootMargin: '-100px' })

    if (landing?.value?.commonData.hasOtherCourses) {
      landingStore.getCourses(landing?.value?.commonData.slug, { isPromo: Boolean(promo?.value) })
    }

    startScreen.value?.$el && observer.value.observe(startScreen.value.$el)

    if (route.query.login === 'true' && !user?.value) {
      userStore.login()
    }

    if (route.query.popup === 'paid') {
      smartComponentsStore.set(SmartComponents.PaymentModal, { accessType: AccessTypeEnum.Paid, isShow: true })
    }

    if (route.query.popup === 'free') {
      smartComponentsStore.set(SmartComponents.PaymentModal, { accessType: AccessTypeEnum.Free, isShow: true })
    }

    if (!isUserSubscriptionActive.value && (route.query.popup === 'subscription' || (isSubscribeOpenModal.value && user?.value))) {
      if (!user?.value) {
        userStore.login()
      } else {
        smartComponentsStore.set(SmartComponents.PaymentModal, {
          accessType: AccessTypeEnum.Paid,
          isShow: true,
          isSubcribeProgress: true,
        })

        isSubscribeOpenModal.value = false
      }
    }

    if (isUserSubscriptionActive.value && route.query.popup === 'openSubscriptionCourse') {
      subscribesStore.openCourse({
        nomenclature_id: landing?.value?.commonData.nomenclature_id,
        subscription_plan_id: activeSubscription?.value?.id,
      }).then(() => {
        smartComponentsStore.set(SmartComponents.PaymentModal, {
          isShow: false,
          isSubcribeProgress: false,
          isThanksPopupOpen: true,
          finishModalData: {
            title: 'Ура, курс открыт',
            description: 'Открыли доступ к&nbsp;выбранному курсу. Больше интересного по&nbsp;подписке&nbsp;&mdash; в&nbsp;нашем каталоге. Ищите курсы с&nbsp;пометкой Pro',
            buttonText: 'Начать учиться',
            buttonTheme: 'senary'
          }
        })
      }).catch((error) => {
        smartComponentsStore.set(SmartComponents.PaymentModal, {
          isShow: false,
          isSubcribeProgress: false,
          isThanksPopupOpen: true,
          finishModalData: {
            title: 'Ошибка!',
            description: error.data.message || 'Произошла ошибка',
            buttonText: 'Закрыть',
            buttonTheme: 'senary'
          }
        })
      })
    }
  })

  onUnmounted(() => {
    startScreen.value?.$el && observer.value?.unobserve(startScreen.value.$el)
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/utils/styles/mixins/UiZIndex' as *;

  // стили лейаута
  @use '@academica-box/styles/UiContainer/variables' as *;

  .layout {
    min-height: 100vh;
  }

  .layout__content {
    display: grid;
    grid-gap: 20px;
    grid-template-rows: auto 1fr;
    padding-top: 20px;
    padding-bottom: 70px;

    @include media(lg) {
      grid-gap: 48px;
      padding-top: 48px;
      padding-bottom: 96px;
    }

    @include media(xl) {
      grid-gap: 26px;
    }

    @include media(xxl) {
      grid-gap: 0;
    }
  }

  .layout__back-button {
    @include media(lg) {
      display: none;
    }
  }

  .layout__breadcrumbs-list {
    @include media(md-max) {
      display: none;
    }
  }
  // конец стилей лейаута

  .course-page {
    @include media(sm-max) {
      overflow-x: hidden;
    }

    @include media(md-max) {
      @include z-index(base)
    }
  }

  .course-page__content {
    margin-bottom: 56px;

    @include media(lg) {
      width: 928px;
      margin: 0 auto;
    }

    @include media(xl) {
      width: 1062px;
    }

    @include media(xxl) {
      width: 1378px;
    }
  }

  .course-page__content-wrapper {
    margin-bottom: 56px;

    @include media(lg) {
      display: grid;
      grid-column-gap: 32px;
      grid-template-columns: 608px auto;
      margin-bottom: 96px;
    }

    @include media(xl) {
      grid-column-gap: 51px;
      grid-template-columns: 672px auto;
      width: 1062px;
    }

    @include media(xxl) {
      grid-column-gap: 152px;
      grid-template-columns: 816px auto;
    }
  }

  .course-page__blocks-wrapper {
    @include media(lg) {
      grid-row: 1/-1;
      grid-column: 1/-1;
    }
  }

  .course-page__course-card {
    @include media(lg) {
      @include z-index(sticky, elevated);

      --headerHeight: 64px;
      --topOffset: -32px;

      top: calc(5px + var(--headerHeight) + (var(--topOffset) * -1)) ;
      z-index: 1;
      grid-row: 1/-1;
      grid-column: 2/-1;
      align-self: flex-start;
      width: fit-content;
      transform: translateY(var(--topOffset));
    }

    @include media(1600) {
      --topOffset: -16px;
    }
  }

  .app--with-promo-banner .course-page__course-card {
    @include media(lg) {
      --bannerHeight: 72px;
      top: calc(5px + var(--headerHeight) + var(--bannerHeight) + (var(--topOffset) * -1)) ;
    }
  }

  .course-page__block {
    &:not(:last-child) {
      margin-bottom: 56px;

      @include media(lg) {
        margin-bottom: 96px;
      }
    }

    &--grey {
      @include media(lg) {
        margin-right: -32px;
        margin-left: -32px;
      }

      @include media(xl) {
        margin-right: -77px;
        margin-left: -77px;
      }

      @include media(xxl) {
        margin-right: 0;
        margin-left: 0;
      }

      @include media(1600) {
        margin-right: -80px;
        margin-left: -80px;
      }
    }

    &--start-screen {
      @include media(lg) {
        grid-row: 1/2;
        margin-top: 16px;
      }

      @include media(xl) {
        margin-top: 38px;
      }

      @include media(xxl) {
        margin-top: 64px;
      }
    }
  }

  .course-page__mobile-price {
    @include z-index(fixed, navigation);

    bottom: 56px;
    transform: translateY(200%);
    transition: transform 0.2s ease-in-out;
    will-change: transform;

    @include media(lg) {
      display: none;
    }

    &--visible {
      transform: translateY(0);
    }
  }
</style>
